<div class="new-ticket-page">
  <div class="new-ticket-container">
    <h1 class="ticket-title">New Support Ticket</h1>
    <p class="ticket-subtitle">
      Please describe your issue in detail and attach supporting documents (PDF only).
    </p>

    <form [formGroup]="ticketForm" (ngSubmit)="submit()" autocomplete="off" novalidate>
      <div class="form-group">
        <label class="form-label" for="ticket-issue">
          Issue <span class="required-mark">*</span>
        </label>

        <input
          id="ticket-issue"
          type="text"
          class="form-input"
          formControlName="issue"
          name="support-ticket-issue"
          maxlength="150"
          placeholder="Enter issue title"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          aria-label="Issue"
        />
        <div class="inline-error" *ngIf="issueControl?.touched && issueControl?.hasError('required')">
          Issue is required.
        </div>
        <div class="inline-error" *ngIf="issueControl?.touched && issueControl?.hasError('maxlength')">
          Issue cannot exceed {{ maxIssueLength }} characters.
        </div>
      </div>

      <div class="form-group">
        <label class="form-label" for="ticket-description">
          Description <span class="required-mark">*</span>
        </label>

        <div class="textarea-wrapper">
          <textarea
            id="ticket-description"
            class="form-textarea"
            formControlName="description"
            maxlength="1500"
            aria-label="Description"
          ></textarea>
          <span class="textarea-placeholder" *ngIf="!descriptionControl?.value">
            Please describe your issue in detail...
          </span>
        </div>

        <div class="char-counter">{{ descriptionLength }}/{{ maxDescriptionLength }}</div>
        <div class="inline-error" *ngIf="descriptionControl?.touched && descriptionControl?.hasError('required')">
          Description is required.
        </div>
        <div class="inline-error" *ngIf="descriptionControl?.touched && descriptionControl?.hasError('maxlength')">
          Description cannot exceed {{ maxDescriptionLength }} characters.
        </div>
      </div>

      <div class="form-group upload-section">
        <label class="form-label">Upload PDF</label>

        <div
          class="upload-box"
          tabindex="0"
          role="button"
          aria-label="Upload PDF"
          [class.dragover]="isDragOver"
          (click)="fileInput.click()"
          (keydown.enter)="fileInput.click()"
          (keydown.space)="$event.preventDefault(); fileInput.click()"
          (drop)="onFileDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
        >
          <span class="material-icons upload-icon" aria-hidden="true">cloud_upload</span>
          <div class="upload-title">Drag &amp; Drop PDF file here</div>
          <div class="upload-browse">or browse files</div>
          <div class="upload-helper">PDF only • Max file size: 5MB</div>

          <input
            #fileInput
            type="file"
            hidden
            accept=".pdf,application/pdf"
            (change)="onFileSelected($event)"
          />
        </div>

        <div class="uploaded-file" *ngIf="selectedFile">
          <div class="file-left">
            <span class="material-icons file-icon" aria-hidden="true">picture_as_pdf</span>
            <div class="file-info">
              <div class="file-name">{{ selectedFile?.name }}</div>
              <div class="file-size">{{ selectedFileSizeLabel }}</div>
            </div>
          </div>

          <button
            type="button"
            class="remove-file"
            aria-label="Remove uploaded file"
            (click)="removeFile(fileInput, $event)"
          >
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </div>

        <div *ngIf="fileError" class="inline-error">{{ fileError }}</div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn-cancel" (click)="cancel()">Cancel</button>
        <button
          type="submit"
          class="btn-submit"
          [disabled]="submitting || uploadInProgress || ticketForm.invalid"
        >
          <span class="submit-spinner" *ngIf="submitting"></span>
          <span>{{ submitting ? 'Submitting...' : 'Submit Ticket' }}</span>
        </button>
      </div>
    </form>
  </div>

  <div
    class="cancel-confirmation-overlay"
    *ngIf="showCancelConfirmation"
    (click)="closeCancelConfirmation()"
  >
    <div
      class="cancel-confirmation-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cancel-confirmation-title"
      aria-describedby="cancel-confirmation-message"
      (click)="$event.stopPropagation()"
    >
      <h2 id="cancel-confirmation-title" class="cancel-confirmation-title">Cancel ticket creation?</h2>
      <p id="cancel-confirmation-message" class="cancel-confirmation-message">
        Are you sure you want to cancel? Your entered ticket details will be lost.
      </p>

      <div class="cancel-confirmation-actions">
        <button type="button" class="btn-cancel-dialog-secondary" (click)="closeCancelConfirmation()">
          No
        </button>
        <button type="button" class="btn-cancel-dialog-primary" (click)="confirmCancel()">
          Yes, Cancel
        </button>
      </div>
    </div>
  </div>
</div>